import { render, staticRenderFns } from "./UpgraderItemElement.vue?vue&type=template&id=4951dfcf&scoped=true"
import script from "./UpgraderItemElement.vue?vue&type=script&lang=js"
export * from "./UpgraderItemElement.vue?vue&type=script&lang=js"
import style0 from "./UpgraderItemElement.vue?vue&type=style&index=0&id=4951dfcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4951dfcf",
  null
  
)

export default component.exports